import React from 'react';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { USDCurrencyFullFormatter } from 'Helpers/Formats';
import Typography from 'Components/UI/Typography';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';

function PortfolioCategory({ category }) {
  const { logPortfolioList } = useManagedAccountPageEventLogger();


  return <>
    <Box display="flex" gap={8} justifyContent="space-between" alignItems="center">
      <Box display="flex" gap={8} alignItems="center" onClick={() => logPortfolioList(category.name)}>
        <FiberManualRecordIcon style={{ color: category.color }} />
        <Typography>{category.name}</Typography>
      </Box>
      <Typography>{USDCurrencyFullFormatter.format(category.value)}</Typography>
    </Box>
  </>;
}

export default function ManagedAccountPortfolioCategories({ tickerClassifications }) {
  return tickerClassifications.map(ticker => <PortfolioCategory key={ticker.name} category={ticker} />);
}
